import CLPLabel from 'owa-mail-store/lib/store/schema/CLPLabel';
import CLPResponse, { LabelRawResponse } from '../store/schema/CLPLabelResponse';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import CLPUserLabelStore from '../store/schema/CLPUserLabelStore';

export default function(CLPResponse: CLPResponse): CLPUserLabelStore {
    if (!CLPResponse || !CLPResponse.value) {
        return { userLabels: [], learnMoreUrl: '' };
    }

    let { value } = CLPResponse;
    const userLanguage = getUserConfiguration().SessionSettings.UserLanguage;
    let idLabelMap: { [key: string]: CLPLabel } = {};
    let learnMoreUrl: string = '';

    value.forEach(label => {
        if (label.Setting_enabled == 'true') {
            if (!learnMoreUrl && label.PolicySetting_customurl) {
                learnMoreUrl = label.PolicySetting_customurl;
            }
            idLabelMap[label.Id] = convertCLPResponseLabelToLabelObject(label, userLanguage);
        }
    });

    Object.keys(idLabelMap).forEach(labelId => {
        const label = idLabelMap[labelId];
        if (label.parentId) {
            let labelParentObject = idLabelMap[label.parentId];
            if (labelParentObject) {
                label.infobarDisplayText = `${labelParentObject.displayName}\\${label.displayName}`;
                labelParentObject.children.push(label);
            }
            // There are at most two levels of labels.
            // So it's safe to remove the label from the map
            // if a label is already been added as other label's chilren
            delete idLabelMap[labelId];
        }
    });

    return {
        userLabels: sortUserLabels(Object.values(idLabelMap)),
        learnMoreUrl,
    };
}

function convertCLPResponseLabelToLabelObject(
    labelResp: LabelRawResponse,
    userLanguage: string
): CLPLabel {
    const displayName =
        labelResp[`DisplayName_${userLanguage}`] || labelResp['DisplayName_Fallback'];
    return {
        id: labelResp.Id,
        parentId: labelResp.ParentId,
        displayName: displayName,
        infobarDisplayText: displayName,
        tooltip: labelResp.Setting_tooltip, // this is currently not being localized, since the backend localization is not ready yet.
        settingOrder: parseInt(labelResp.Setting_order),
        isDefault: labelResp.PolicySetting_default == 'true',
        isEncryptingLabel: labelResp.RightsProtectMessage_Disabled
            ? labelResp.RightsProtectMessage_Disabled == 'false'
            : false,
        isAutoLabelingOn:
            labelResp.AutoLabeling_SensitiveTypeIds &&
            labelResp.AutoLabeling_SensitiveTypeIds.length > 0,
        children: [],
    };
}

function sortUserLabels(userLabels: CLPLabel[]): CLPLabel[] {
    if (!userLabels) {
        return null;
    }
    userLabels.sort(compareLabels);
    userLabels.forEach(label => {
        if (label.children) {
            label.children.sort(compareLabels);
        }
    });

    return userLabels;
}

function compareLabels(labelA: CLPLabel, labelB: CLPLabel): number {
    return labelA.settingOrder - labelB.settingOrder;
}
